export const convertAppThemeToStreamChatTheme = (appTheme: 'light' | 'dark') => {
  if (appTheme === 'dark') return 'str-chat__theme-dark';

  return 'str-chat__theme-light';
};
